let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cP5Vm")).then(() => parcelRequire('7z1Gc'));